import { S as SearchPriceSpecial } from './index2.js';
import { p as padDateString } from './pad-date-string.js';
import { t as translateDate } from './translate-date.js';

/**
 *  ** Book Visit
 * @exports bs_73
 * @category engines
 */
const factory = function factory({ window, document, thn }) {
    let refreshPrice = null;
    const roomsBlacklistRegex = /Motorhomes ZONE A|Motorhomes in Zones B, C, D|Tent spot/;
    const usersBlacklist = [1049640];
    return {
        languageCheck(ctx) {
            return new Promise((resolve, reject) => {
                const langMap = {
                    1: 'sv',
                    2: 'en',
                    5: 'no',
                    English: 'en',
                    Svenska: 'sv',
                };
                const langSel = document.querySelector('.nav__item--lang')?.textContent || document.querySelector('.bv-language img')?.getAttribute('alt') || '';
                const langImgElm = document.querySelector('.bv-language img')?.src?.split('/')?.pop()?.slice(0, 2) || '';
                const langIdParam = thn.parseUrlParameter('langid') || '';
                const finalLang = langMap[langSel]
                    || langMap[langIdParam] || langImgElm;
                let lang = finalLang === 'nb' ? 'no' : finalLang;
                if (window.location.hostname.match(/geilolia/)) { // https://geilolia.no
                    const language = window.location.pathname.match(ctx.urlRe);
                    lang = language && language[1];
                    if (lang && ctx.langs.test(lang)) {
                        resolve(lang);
                    }
                    resolve('no');
                }
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
                const langElm = document.querySelector('.cb-js-langpicker-trigger > img');
                lang = langElm?.getAttribute('src')?.match(/([^/]+)\.png$/)?.[1]?.substr(0, 2);
                if (lang && ctx.langs.test(lang)) {
                    lang = lang === 'nb' ? 'no' : lang;
                    resolve(lang);
                    return;
                }
                if (thn.data.accountUserId === 1037998 && window.location.hostname.match(/^eng/)) {
                    resolve('en');
                }
                // https://gjestehuset102.no/
                // https://booking.smarthotel.no/en/oslo/accommodation/list
                // https://highland.no/
                // https://bardola.no/
                if ([1040367, 1044243, 1047643].includes(thn.data.accountUserId)) {
                    lang = document.documentElement?.getAttribute('lang')?.split('-')[0];
                    if (lang && ctx.langs.test(lang)) {
                        lang = lang === 'nb' ? 'no' : lang;
                        resolve(lang);
                    }
                }
                const menuBookingEl = document.querySelector('.menu-accommodation');
                const onyxenHotelCheck = thn.data.propertyId === 1030887 && menuBookingEl;
                if (onyxenHotelCheck) {
                    lang = menuBookingEl?.textContent?.toLowerCase().includes('boka rum') ? 'sv' : 'en';
                    resolve(lang);
                    return;
                }
                reject(new Error('no_language'));
            });
        },
        onStateChange: thn.debounce(() => {
            thn.pageCheck();
        }, 400),
        onHashChange: thn.debounce(() => {
            thn.pageCheck();
        }, 600),
        generateSearchUrl(ctx) {
            const url = new URL(ctx.baseUrl);
            const validUrl = url.hostname.match(/booking|book|boka/) && !url.pathname.match(/specific-package/);
            // https://booking.maryhillestate.com/accommodation/specific-package/the-iconic-offer-limited?roomconfig=a2&year=2024&month=11&day=18&staylength=1&allpackages=true&packageid=41ebae2b-ec06-4244-ad08-98435846986a
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            if (url.pathname.match(/^\/\w{2}\//)) {
                url.pathname = url.pathname.replace(/^\/\w{2}\//, '/[language]/');
            }
            const dateBegin = ctx.data?.dateBegin;
            const dateEnd = ctx.data?.dateEnd;
            const dateBeginParts = dateBegin?.split(/[-/\\]/);
            const numberOfNightsString = thn.daysBetween(dateBegin, dateEnd)?.toString() || '';
            const rooms = ctx.data.roomsDispo?.length || 1;
            let guests = '';
            for (let i = 0; i < rooms; i += 1) {
                guests += `a${ctx.data.roomsDispo?.[i].adults || 2}`;
                if (ctx.data.roomsDispo?.[i]?.children) {
                    const children = ctx.data.roomsDispo?.[i]?.childrenAges?.length || 0;
                    for (let j = 0; j < children; j += 1) {
                        guests += `_c${ctx.data.roomsDispo?.[i].childrenAges?.[j] || 0}`;
                    }
                }
                guests += i !== rooms - 1 ? '|' : '';
            }
            url.searchParams.set('roomconfig', guests);
            url.searchParams.set('year', dateBeginParts[0]);
            url.searchParams.set('month', dateBeginParts[1]);
            url.searchParams.set('day', dateBeginParts[2]);
            url.searchParams.set('staylength', numberOfNightsString);
            url.searchParams.set('allpackages', 'true');
            ctx.newUrl = url.toString();
            return ctx;
        },
        priceObserveDom(ctx) {
            const resultContainer = document.querySelector('.book-section-accommodation, .book-section-package');
            if (resultContainer && !refreshPrice) {
                refreshPrice = thn.debounce(() => {
                    const loading = !thn.isVisible(document.querySelector('#outer_div'));
                    if (!loading) {
                        ctx.widget.refresh().catch(() => { });
                    }
                }, 600);
                thn.observeDom(resultContainer, refreshPrice, {
                    childList: true,
                    subtree: true,
                    attributes: false,
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(resultContainer, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
            // hide price when making a new search to avoid showing old prices
            const updatePriceOnDataLayerEvent = thn.debounce(() => {
                if (ctx.widget.isSet()) {
                    ctx.widget.update().catch(() => { });
                }
            }, 500);
            thn.bus.on('dataLayer:event.view_item_list', updatePriceOnDataLayerEvent, true);
            thn.pageUnload(() => {
                thn.bus.detach('dataLayer:event.view_item_list', updatePriceOnDataLayerEvent);
            });
        },
        priceParseData_v1() {
            // To avoid returning a widgetData with no availability when the page is loading
            const pageIsCharging = document.querySelector('.mantine-Skeleton-root');
            if (pageIsCharging) {
                return null;
            }
            const priceSpecial = window.location.pathname.match(/specific-package/) ? SearchPriceSpecial.Generic : SearchPriceSpecial.None;
            const dataLayer = window.dataLayer || [];
            // When coming from a non availability search, sometimes the parameters on the url are not populated
            const previousUrl = thn.objectGet(dataLayer, 'gtm.oldUrl') ?? '';
            const oldUrl = typeof previousUrl === 'string' && previousUrl ? new URL(previousUrl) : undefined;
            // Dates
            let dateBegin = thn.dataLayerHelper.get('bv_date_search_params.arrival_date');
            let dateEnd = thn.dataLayerHelper.get('bv_date_search_params.departure_date');
            let nights;
            if (!dateBegin || !dateEnd) {
                const checkinYear = thn.parseUrlParameter('year') ?? '';
                const checkinMonth = thn.parseUrlParameter('month') ?? '';
                const checkinDay = thn.parseUrlParameter('day') ?? '';
                const dateBeginParsed = checkinYear && checkinMonth && checkinDay ? `${checkinYear}-${checkinMonth}-${checkinDay}` : '';
                const dateBeginDl = thn.objectGet(dataLayer, 'arrival_date') ?? '';
                const dateEndDl = thn.objectGet(dataLayer, 'departure_date') ?? '';
                dateBegin = (typeof dateBeginDl === 'string' ? dateBeginDl.replace(/-/g, '/') : '') ?? padDateString(dateBeginParsed) ?? '';
                nights = thn.parseNumber(thn.parseUrlParameter('staylength')) ?? 1;
                if (dateBeginParsed) {
                    dateEnd = thn.dateToString(thn.addDays(dateBeginParsed, nights)) ?? '';
                }
                else if (typeof dateEndDl === 'string') {
                    dateEnd = dateEndDl.replace(/-/g, '/');
                }
            }
            else {
                dateBegin = dateBegin?.replace(/-/g, '/');
                dateEnd = dateEnd.replace(/-/g, '/');
                nights = thn.daysBetween(dateBegin, dateEnd) || 1;
            }
            // Guests
            const guests = oldUrl?.pathname?.includes('no-availability') ? oldUrl?.searchParams?.get('roomconfig')?.split('|') : thn.parseUrlParameter('roomconfig')?.split('|') ?? [];
            let roomInfo = [];
            const hotelsDontRefreshRoomConfig = [1160128, 1158003];
            // in specific packages URL do not refresh the roomconfig, so we need to get the data from the dataLayer
            if (hotelsDontRefreshRoomConfig.includes(thn.data.propertyId) && window.location.pathname.match(/specific-package/)) {
                if (thn.dataLayerHelper.get('bv_date_search_params.number_of_rooms') === 1) {
                    const info = thn.dataLayerHelper.get('bv_date_search_params');
                    roomInfo = [{
                            adults: info?.number_of_adults || 2,
                            children: info?.number_of_children || 0,
                            childrenAges: info?.number_of_children ? info?.child_ages || [] : [],
                        }];
                }
                else {
                    return null;
                }
            }
            else {
                roomInfo = guests?.map((occupancy) => {
                    const guest = occupancy.split('_') ?? [];
                    return {
                        adults: thn.parseNumber(guest[0]) ?? 2,
                        children: guest.length - 1,
                        childrenAges: guest.length > 1 ? guest.slice(1).map((age) => thn.parseNumber(age)).filter((age) => age !== undefined) : [],
                    };
                }) ?? [];
            }
            const currencyRegex = /Divisa|Currency|Referensvaluta|Valuutta/i;
            const currencyEl = Array.from(document.querySelectorAll('[aria-label]'))?.filter(el => currencyRegex.test(el.getAttribute('aria-label') ?? ''));
            const currency = currencyEl?.[0]?.textContent ?? thn.dataLayerHelper.get('ecommerce.currency') ?? thn.objectGet(dataLayer, 'currency') ?? 'sek';
            const prices = document.evaluate(`//p[
          contains(
            translate(normalize-space(.), 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', 'abcdefghijklmnopqrstuvwxyz'),
            '${currency.toLowerCase()}'
          )
        ]`, document, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
            const results = [];
            for (let i = 0; i < prices.snapshotLength; i += 1) {
                const item = prices.snapshotItem(i);
                const roomTitle = item instanceof HTMLElement
                    ? item.closest('div[style*=cursor]')?.parentElement?.querySelector('.illvHj')?.textContent ?? null
                    : null;
                if (usersBlacklist.includes(thn.data.accountUserId) && roomsBlacklistRegex.test(roomTitle ?? '')) {
                    break;
                }
                const closestSpan = item && document.evaluate('.//following::span[1]', item, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
                const span1Text = closestSpan ? closestSpan?.textContent?.trim() : null;
                let span2Text = null;
                // If there's a comma, it's because it's separating the children.
                if (span1Text && span1Text.includes(',')) {
                    span2Text = thn.parseNumber(span1Text.split(',')[1]);
                }
                else if (closestSpan) {
                    // If there's no comma, search for the next visually closest span
                    const nextSpan = document.evaluate(`.//following-sibling::span[1] | 
       ../following-sibling::*[1]//span[1]`, closestSpan, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
                    span2Text = nextSpan ? thn.parseNumber(nextSpan?.textContent?.trim()) : null;
                }
                const price = thn.parseNumber(item?.textContent?.trim());
                if (price) {
                    results.push({
                        price,
                        guests: span2Text || 2,
                    });
                }
            }
            let finalPrice = 0;
            const roomsByPrices = [];
            // To calculate the final price, we take the minimum price of each room searched
            for (let i = 0; i < roomInfo?.length; i += 1) {
                const lowerPricesByRoom = results.filter((rate) => {
                    const room = roomInfo?.[i];
                    const secondRoomComparison = (rate.guests) === ((roomInfo?.[i + 1]?.adults ?? 0) + (roomInfo?.[i + 1]?.children ?? 0));
                    return room && ((rate.guests) === (room.adults + room.children) || secondRoomComparison);
                });
                const price = Math.min(...lowerPricesByRoom
                    .map((item) => item.price)
                    .filter((value) => typeof value === 'number'));
                roomsByPrices.push({
                    price,
                });
            }
            finalPrice = roomsByPrices
                .map((item) => item.price)
                .filter((n) => typeof n === 'number')
                .reduce((acc, val) => acc + val, 0);
            if (!thn.empty(results) && currency && dateBegin && dateEnd) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: roomInfo,
                    price: finalPrice / nights,
                    currency,
                    priceSpecial,
                };
            }
            if (thn.empty(results) && dateBegin && dateEnd) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: roomInfo,
                    noRooms: true,
                };
            }
            return null;
        },
        priceParseData_v2() {
            // Dates
            const checkinYear = thn.parseUrlParameter('year') ?? '';
            const checkinMonth = thn.parseUrlParameter('month') ?? '';
            const checkinDay = thn.parseUrlParameter('day') ?? '';
            const dateBeginParsed = checkinYear && checkinMonth && checkinDay ? `${checkinYear}-${checkinMonth}-${checkinDay}` : '';
            const dateBegin = padDateString(dateBeginParsed);
            const nights = thn.parseNumber(thn.parseUrlParameter('staylength')) ?? 1;
            const dateEnd = dateBeginParsed ? thn.dateToString(thn.addDays(dateBeginParsed, nights)) : '';
            const propertiesWithSameSelector = [1156694].includes(thn.data.propertyId); // Properties with the same selector on Mobile and Desktop
            const earlyExithotels = [1160128, 1158003].includes(thn.data.propertyId);
            if ((!dateBegin || !dateEnd) || earlyExithotels) {
                return null;
            }
            const guests = thn.parseUrlParameter('roomconfig')?.split('|') ?? [];
            const roomInfo = guests.map((occupancy) => {
                const guest = occupancy.split('_') ?? [];
                return {
                    adults: thn.parseNumber(guest[0]) ?? 2,
                    children: guest.length - 1,
                    childrenAges: guest.length > 1 ? guest.slice(1).map((age) => thn.parseNumber(age)).filter((age) => age !== undefined) : [],
                };
            });
            // when this selector is on the page, only appears data from half of the rooms, we cannot collect the case of multi-rooms.
            const selector = document.querySelector('div[data-testid="room_card_tile_group"], div[data-testid=room_group_card_tile_group], div[data-testid="tile_large_base"]');
            const propertiesFilteringRooms = [1158257].includes(thn.data.propertyId);
            if ((selector && window.innerWidth > 1200) || (selector && propertiesWithSameSelector)) {
                if (guests.length > 1) {
                    return null;
                }
                let prices = Array.from(document.querySelectorAll('div[data-testid^="tile_"] div.slideIn > p > span:first-child, div[data-testid="classic_base"] div.slideIn p:first-child'));
                if (propertiesFilteringRooms) {
                    prices = prices.filter((price) => {
                        const heading = price.parentElement?.parentElement?.parentElement?.parentElement
                            ?.querySelector('h1')?.textContent?.trim();
                        return heading ? !['Dormitory', 'Seng på fællesværelse'].includes(heading) : false;
                    });
                }
                const finalPrices = prices?.map((price) => thn.parseNumber(price.textContent)).filter((value) => typeof value !== 'undefined');
                const currency = thn.parseCurrency(prices?.[0]?.textContent);
                if (!thn.empty(finalPrices) && currency) {
                    return {
                        dateBegin,
                        dateEnd,
                        roomsDispo: [roomInfo[0]],
                        price: Math.min(...finalPrices) / nights,
                        currency,
                    };
                }
            }
            else {
                // We collect each price, with the guests that belongs to it
                const isTablet = window.innerWidth < 1200 && window.innerWidth > 580;
                const pricesSel = isTablet ? '.bv_card > div:nth-child(2)> div > div:nth-child(2) > div > div, .bv_card > div > div > div:nth-child(3), [data-testid="tile_large_base"] > div:nth-child(3) > div:nth-child(1) > div' : '.rate_alt_outer > div:last-child > div:not([aria-haspopup="dialog"]), div.mantine-Skeleton-root > div > div > div:last-child > div:has(p), [data-testid=package_card_plate_package_info] + div > div, [data-testid=tile_base] > div:nth-child(2)>div>div';
                let pricesEls = Array.from(document.querySelectorAll(pricesSel));
                if (propertiesFilteringRooms) {
                    pricesEls = pricesEls.filter((price) => {
                        const heading = price.parentElement?.parentElement?.querySelector('h1')?.textContent?.trim();
                        return heading ? !['Dormitory', 'Seng på fællesværelse'].includes(heading) : false;
                    });
                }
                const priceAndGuests = pricesEls.map((price) => {
                    const roomPrice = thn.parseNumber(price.querySelector('p:last-of-type')?.textContent);
                    let finalPriceAndGuests;
                    if (!propertiesFilteringRooms) {
                        let guestsRoom = price.querySelector(':scope > div:last-child');
                        if (!guestsRoom) {
                            guestsRoom = price.nextElementSibling;
                        }
                        const guestsPlus = {
                            adults: 0,
                            children: 0,
                            childrenAges: [],
                        };
                        const checkGuests = guestsRoom?.querySelector('span:first-child')?.textContent?.split(',');
                        if (!thn.empty(checkGuests) && checkGuests.length !== 1) {
                            guestsPlus.adults = thn.parseNumber(checkGuests[0]) ?? 2;
                            guestsPlus.children = thn.parseNumber(checkGuests[1]) ?? 0;
                            guestsPlus.childrenAges = guestsRoom?.querySelector('span:first-child')?.textContent?.split('(')?.[1]?.split(',')?.map((ages) => thn.parseNumber(ages)).filter((value) => typeof value !== 'undefined') || [];
                        }
                        else {
                            guestsPlus.adults = !guestsRoom?.querySelector('span:first-child')?.textContent?.match(/night|nat/) ? (thn.parseNumber(guestsRoom?.querySelector('span:first-child')?.textContent) ?? 2) : 2;
                            guestsPlus.children = thn.parseNumber(guestsRoom?.querySelector('span:nth-child(2)')?.textContent) ?? 0;
                            guestsPlus.childrenAges = guestsRoom?.querySelector('span:nth-child(3)')?.textContent?.split(',')?.map((ages) => thn.parseNumber(ages)).filter((value) => typeof value !== 'undefined') || [];
                        }
                        finalPriceAndGuests = {
                            price: roomPrice,
                            guests: guestsPlus,
                        };
                    }
                    else {
                        finalPriceAndGuests = {
                            price: roomPrice,
                            guests: roomInfo[0],
                        };
                    }
                    return finalPriceAndGuests;
                }).filter((value) => !!value.price);
                // To calculate the final price, we take the minimum price of each room searched
                let totalPrice = 0;
                for (let i = 0; i < roomInfo.length; i += 1) {
                    const rooms = priceAndGuests.filter((occupancy) => (occupancy.guests.adults + occupancy.guests.children) === (roomInfo[i].adults + roomInfo[i].children));
                    const prices = Array.isArray(rooms) && rooms.length > 0 ? rooms.map((room) => room.price).filter((value) => typeof value !== 'undefined') : [];
                    const price = prices.length !== 0 ? Math.min(...prices) : null;
                    if (!price) {
                        return {
                            dateBegin,
                            dateEnd,
                            roomsDispo: [roomInfo[i]],
                            noRooms: true,
                        };
                    }
                    totalPrice += price;
                }
                const currency = thn.parseCurrency(document.querySelector('.rate_tile > div:last-child > div:first-child > span')?.textContent) ?? thn.parseCurrency(document.querySelector('.rate_alt_outer > div:last-child > div > p:last-of-type, .rate_tile > div:last-child > div:first-child > p:last-of-type, [data-testid=package_card_plate_package_info] + div > div p:first-child, [data-testid=tile_base] > div:nth-child(2)>div>div p:first-child span')?.textContent);
                const noAvailability = window.location.pathname.match(/no-availability/);
                let priceSpecial;
                if (thn.parseUrlParameter('packageid') || window.location.pathname.match(/package/)) {
                    priceSpecial = SearchPriceSpecial.Generic;
                }
                if (totalPrice > 0 && currency) {
                    return {
                        dateBegin,
                        dateEnd,
                        roomsDispo: roomInfo,
                        price: totalPrice / nights,
                        currency,
                        priceSpecial,
                    };
                }
                if (noAvailability) {
                    return {
                        dateBegin,
                        dateEnd,
                        roomsDispo: roomInfo,
                        noRooms: true,
                    };
                }
            }
            return null;
        },
        bookingParseData() {
            const bookingDataByWindow = window.booking;
            const bookingId = thn.dataLayerHelper.get('ecommerce.transaction_id') || bookingDataByWindow?.bookingCode || thn.parseUrlParameter('bookingcode') || thn.dataLayerHelper.get('transaction_id')
                || document.querySelector('b.bv-txt-required')?.textContent?.trim();
            // Guests
            const adults = thn.dataLayerHelper.get('ecommerce.number_adults');
            const children = thn.dataLayerHelper.get('ecommerce.number_children');
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const ecommerceItems = thn.dataLayerHelper.get('ecommerce.items') || [];
            const isNotBed = !!(adults && children && adults + children === 0) || (!thn.dataLayerHelper.get('ecommerce.package_name') && ecommerceItems?.[0]?.item_category !== 'Room');
            if (!bookingId || isNotBed) {
                return {
                    set: false,
                };
            }
            const currency = thn.dataLayerHelper.get('ecommerce.currency') || thn.dataLayerHelper.get('currency') || thn.parseCurrency(document.querySelector('.bv-value')?.textContent);
            const price = thn.dataLayerHelper.get('ecommerce.value') || thn.dataLayerHelper.get('value') || thn.parseNumber(bookingDataByWindow?.TotalAmount);
            let dateBegin = thn.dataLayerHelper.get('ecommerce.booking_start_date')?.replace(/-/g, '/');
            let dateEnd = thn.dataLayerHelper.get('ecommerce.booking_end_date')?.replace(/-/g, '/');
            // dates
            if (!thn.empty(bookingDataByWindow?.Products) && bookingDataByWindow?.Products[0].Start) {
                dateBegin = bookingDataByWindow.Products[0].Start.replace(/(\d+)\D+(\d+)\D+(\d+).*/, '$1/$2/$3');
            }
            if (!thn.empty(bookingDataByWindow?.Products) && bookingDataByWindow?.Products[0].End) {
                dateEnd = bookingDataByWindow.Products[0].End.replace(/(\d+)\D+(\d+)\D+(\d+).*/, '$1/$2/$3');
            }
            if (!dateBegin && !dateEnd) {
                dateBegin = translateDate(document.querySelector('.dWanAp .ldRAti > p:nth-child(2)')?.textContent ?? '') ?? '';
                dateEnd = translateDate(document.querySelector('.dWanAp .ldRAti > p:nth-child(4)')?.textContent ?? '') ?? '';
            }
            const promocode = thn.dataLayerHelper.get('ecommerce.coupon') || document.querySelector('input[name="PromoCode"]')?.value;
            return {
                bookingId,
                dateBegin,
                dateEnd,
                price,
                currency,
                promocode,
            };
        },
    };
};

export { factory };
